// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import dataTableStyles from "@rpsc/App/SharedStyles/MyAccountPages/List/DataTableStyles";
import { assignBudgetsStyles } from "@rpsc/Overrides/Widgets/Budget/AssignBudgets";
import { mergeWithCss, xScreen } from "@rpsc/XDL/Utilities";
import { css } from "styled-components";

assignBudgetsStyles.enforcementLevelGridItem = {
    width: 12,
    css: css`
        gap: 5px;
        padding: 0 0 10px;
        ${xScreen("lte", "sm")} {
            flex-direction: column;
        }
        ${xScreen("lte", "xs")} {
            padding: 11px 0 8px;
        }
    `,
};

assignBudgetsStyles.titleGridItem = {
    width: [12, 7, 8, 8, 8],
    css: css`
        align-items: center;
        padding: 20px 0 15px;
    `,
};

assignBudgetsStyles.titleText = {
    variant: "h2",
};

assignBudgetsStyles.buttonsGridItem = {
    width: [12, 5, 4, 4, 4],
    css: css`
        justify-content: flex-end;
        padding: 20px 0 15px;
        ${xScreen("lte", "xs")} {
            padding-top: 0;
        }
    `,
};

assignBudgetsStyles.buttonsHidden = {
    css: css`
        width: 100%;
        display: flex;
        ${xScreen("lte", "xs")} {
            padding-top: 15px;
        }
    `,
};

assignBudgetsStyles.cancelButton = {
    variant: "tertiary",
    css: css`
        margin-top: 2px;
        ${xScreen("lte", "xs")} {
            width: 50%;
            margin-top: 0;
        }
    `,
};

assignBudgetsStyles.saveButton = {
    css: css`
        margin-left: 10px;
        margin-top: 2px;
        ${xScreen("lte", "xs")} {
            width: 50%;
            margin-top: 0;
        }
    `,
};

assignBudgetsStyles.filterGridItem = {
    width: 12,
    css: css`
        display: block;
        padding: 7px 0 0;
    `,
};

assignBudgetsStyles.assignBudgetInstructionsGridItem = {
    width: 12,
    css: css`
        padding: 9px 0 10px;
    `,
};

assignBudgetsStyles.createBudgetGridItem = {
    width: 12,
    css: css`
        padding: 15px 0 8px;
        ${xScreen("lte", "xs")} {
            padding: 15px 0;
        }
    `,
};

assignBudgetsStyles.budgetYearGridItem = {
    width: 12,
    css: css`
        padding: 8px 0 0;
    `,
};

assignBudgetsStyles.searchUserWrapper = {
    css: css`
        display: inline-block;
        margin-right: 30px;
        margin-bottom: 15px;
        ${xScreen("lte", "sm")} {
            margin-right: 0;
            width: 50%;
        }
        ${xScreen("lte", "xs")} {
            margin-bottom: 22px;
            width: 100%;
        }
    `,
};

assignBudgetsStyles.wrapper = {
    css: css`
        display: inline-block;
        margin-right: 30px;
        margin-bottom: 15px;
        ${xScreen("lte", "sm")} {
            margin-right: 0;
            width: 50%;
        }
        ${xScreen("lte", "xs")} {
            width: 100%;
        }
    `,
};

assignBudgetsStyles.budgetYearSelect = {
    cssOverrides: {
        formField: css`
            ${xScreen("lte", "sm")} {
                padding-right: 30px;
            }
            ${xScreen("lte", "xs")} {
                padding-right: 0;
            }
        `,
    },
};

assignBudgetsStyles.searchUserSelect = {
    cssOverrides: {
        formField: css`
            ${xScreen("lte", "sm")} {
                padding-right: 30px;
            }
            ${xScreen("lte", "xs")} {
                padding-right: 0;
            }
        `,
    },
};

assignBudgetsStyles.budgetAmountTextField = {
    cssOverrides: {
        formField: css`
            width: auto;
        `,
        formInputWrapper: css`
            width: 150px;
        `,
        inputSelect: css`
            padding-right: 10px;
            &:focus {
                padding-right: 10px;
            }
        `,
    },
};

assignBudgetsStyles.tableGridItem = {
    width: [12, 12, 12, 6, 6],
    css: css`
        padding: 15px 0 8px;
        ${xScreen("lte", "xs")} {
            padding: 15px 0;
        }
    `,
};

assignBudgetsStyles.createBudgetText = {
    ...mergeWithCss(dataTableStyles.noResultsText, {
        css: css`
            margin-bottom: 0;
        `,
    }),
};
